import { createContext, useContext, type ReactNode } from "react";

export type TaxReportingPersistenceConfig = {
  caseId: number;
  documentId: number;
  parentProfileId: number;
};

const TaxReportingPersistenceContext = createContext<TaxReportingPersistenceConfig | null>(
  null,
);

export const TaxReportingPersistenceProvider = ({
  value,
  children,
}: {
  value: TaxReportingPersistenceConfig | null;
  children: ReactNode;
}) => (
  <TaxReportingPersistenceContext.Provider value={value}>
    {children}
  </TaxReportingPersistenceContext.Provider>
);

export const useTaxReportingPersistence = (): TaxReportingPersistenceConfig | null =>
  useContext(TaxReportingPersistenceContext);
